import { render, staticRenderFns } from "./FormatHistory.vue?vue&type=template&id=746803f0&scoped=true"
import script from "./FormatHistory.vue?vue&type=script&lang=js"
export * from "./FormatHistory.vue?vue&type=script&lang=js"
import style0 from "./FormatHistory.vue?vue&type=style&index=0&id=746803f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746803f0",
  null
  
)

export default component.exports